"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var DOMAIN_MAP = {
  'sss.staging.qingting.fm': {
    'host': 'fans.staging.qingting.fm',
    'env': 'stg',
    'wx': 'mark-phone'
  },
  'sss.staging.bjqtthirdbase.com': {
    'host': 'fans.staging.qingting.fm',
    'env': 'stg',
    'wx': 'mark-phone'
  },
  'sss.staging.bjqtforthbase.com': {
    'host': 'fans.staging.qingting.fm',
    'env': 'stg',
    'wx': 'mark-phone'
  },
  'sss.staging.bjqtfifthbase.com': {
    'host': 'fans.staging.qingting.fm',
    'env': 'stg',
    'wx': 'mark-phone'
  },
  'sss.qingting.fm': {
    'host': 'fans.qingting.fm',
    'env': 'prd',
    'wx': 'maikefengrocks'
  },
  'sss.bjqtthirdbase.com': {
    'host': 'fans.qingting.fm',
    'env': 'prd',
    'wx': 'maikefengrocks'
  },
  'sss.bjqtforthbase.com': {
    'host': 'fans.qingting.fm',
    'env': 'prd',
    'wx': 'maikefengrocks'
  },
  'sss.bjqtfifthbase.com': {
    'host': 'fans.qingting.fm',
    'env': 'prd',
    'wx': 'maikefengrocks'
  },
  'm.qingting.fm': {
    'host': 'fans.qingting.fm',
    'env': 'prd',
    'wx': 'qingting_fm'
  },
  'sss.qt.bjqtbase.com': {
    'host': 'fans.qingting.fm',
    'env': 'prd',
    'wx': 'qingting_fm'
  },
  'sss.qt.bjqtsecbase.com': {
    'host': 'fans.qingting.fm',
    'env': 'prd',
    'wx': 'qingting_fm'
  },
  'sss.staging.bjqtbase.com': {
    'host': 'fans.staging.qingting.fm',
    'env': 'stg',
    'wx': 'supervip'
  },
  'sss.staging.bjqtsecbase.com': {
    'host': 'fans.staging.qingting.fm',
    'env': 'stg',
    'wx': 'supervip'
  },
  'bp.staging.qingting.fm': {
    'host': 'fans.staging.qingting.fm',
    'env': 'stg',
    'wx': 'supervip'
  },
  'bp.qingting.fm': {
    'host': 'fans.qingting.fm',
    'env': 'prd',
    'wx': 'supervip'
  }
};

function getUrl(domain) {
  if (DOMAIN_MAP[domain]) {
    return 'https://' + DOMAIN_MAP[domain].host + '/auth/weixin/' + DOMAIN_MAP[domain].wx + '/config';
  }

  return '';
}

var _default = getUrl;
exports["default"] = _default;